import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { canCreateEOI, canUpdateEOI, createExpressionOfInterest, updateExpressionOfInterest, useExpressionOfInterest } from "../../reducers/expressionOfInterestSlice";
import useNetwork from "../../common/hooks/networkHook";
import useCredentials from "../../common/hooks/credentialsHook";
import { deepMerge, writeField } from "../../common/utils/objectUtilities";

const ExpressionOfInterestEditorContext = createContext({});

export const useEOIContext = () => useContext(ExpressionOfInterestEditorContext);

export const ExpressionOfInterestNewProvider = ({ children }) => {
    const network = useNetwork();
    const credentials = useCredentials();
    const [eoi, setEOI] = useState({});

    const update = useCallback((field, value) => {
        setEOI(eoi => {
            const newEOI = JSON.parse(JSON.stringify(eoi));
            if (field === 'data') {
                writeField(newEOI, 'data', deepMerge({}, newEOI.data ?? {}, value));
            } else {
                writeField(newEOI, field, value);
            }
            return newEOI;
        });
    }, []);

    const save = useCallback(() => {
        return createExpressionOfInterest(network, eoi);
    }, [eoi, network]);

    const clear = useCallback(() => setEOI({}), []);

    const value = useMemo(() => ({ eoi, mode: 'new', update, save, clear, disabled: !canCreateEOI(credentials) }), [credentials, eoi, update, save, clear]);
    return <ExpressionOfInterestEditorContext.Provider value={value}>
        {children}
    </ExpressionOfInterestEditorContext.Provider>
}

export const ExpressionOfInterestUpdateProvider = ({ id, children }) => {
    const network = useNetwork();
    const credentials = useCredentials();
    const eoi = useExpressionOfInterest(id);

    const update = useCallback((field, value) => {
        updateExpressionOfInterest(network, { id, [field]: value });
    }, [network, id])

    const value = useMemo(() => ({ eoi, mode: 'edit', update, disabled: !canUpdateEOI(credentials, eoi) }), [eoi, update, credentials]);
    return <ExpressionOfInterestEditorContext.Provider value={value}>
        {children}
    </ExpressionOfInterestEditorContext.Provider>
}